export const ExpenseSourceEnum = {
    0: 'Reimbursement (Associate)',
    1: 'Reimbursement (Clinician)',
    2: 'Corpay',
    3: 'Conferma',
    4: 'Travel Inc',
};
